import { addYears } from 'date-fns';
import Cookies from 'universal-cookie';

const cookie = new Cookies();

const preferredCurrencyCookie = 'preferred-currency-set';
export const setPreferredCurrencyCookie = () => {
    const expires = addYears(new Date(), 1);
    cookie.set(preferredCurrencyCookie, true, {
        domain: '.liveauctioneers.com',
        expires,
        path: '/',
        sameSite: 'none',
        secure: true,
    });
};

export const getPreferredCurrencyCookie = () => {
    return cookie.get(preferredCurrencyCookie);
};
